import type { FC } from 'react';
import clsx from 'clsx';

import { paginationItemContainerClasses } from './classes';

interface PaginationItemProps {
  currentPageIndex: number;
  onClick: (value: number) => void;
  page: number;
  'data-testid'?: string;
}

export const PaginationItem: FC<PaginationItemProps> = ({
  currentPageIndex,
  onClick,
  page,
  'data-testid': dataTestId,
}) => {
  const pageIndex: number = page - 1;
  const isCurrentPage: boolean = pageIndex === currentPageIndex;

  return (
    <a
      onClick={(): void => onClick(pageIndex)}
      aria-current={isCurrentPage ? 'page' : undefined}
      className={clsx(paginationItemContainerClasses({ isCurrentPage }))}
      data-testid={dataTestId}
    >
      {page}
    </a>
  );
};
